// services/productoService.js
import { supabase } from '../../../supabaseClient.js';

//1.
/* export const obtenerProductos = async () => {
  try {
    const { data, error } = await supabase.from('productos_precio').select('*').order("nombre", { ascending: true }) ;
    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    console.error('Error al obtener los productos:', error.message);
    return { success: false, error: error.message };
  }
}; */

export const obtenerProductosConPrecio = async () => {
  try {
    const { data, error } = await supabase
      .from('productos_precio')
      .select('*')
      .eq('estado', true)
      .order('nombre', { ascending: true });

    if (error) throw error;

    return { success: true, data };

  } catch (error) {
    console.error('Error al obtener los productos:', error.message);
    return { success: false, error: error.message };
  }
};

export const obtenerProductosInsumos = async () => {
  try {
    const { data, error } = await supabase
      .from('productos_precio')
      .select('*')
      .eq('estado', true)
      .in('Clase', ['INSUMO'])
      .order('nombre', { ascending: true });

    if (error) throw error;

    return { success: true, data };

  } catch (error) {
    console.error('Error al obtener los productos:', error.message);
    return { success: false, error: error.message };
  }
};


//2.
export const obtenerProductoPorId = async (id) => {
  const { data, error } = await supabase
    .from('productos_precio')
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    console.error('Error al obtener producto:', error.message);
    return { success: false, error: error.message };
  }

  return { success: true, data };
};

//3..////////////////////////////////////////////////////////////
export const crearProductoConPrecio = async (producto) => {

  //  Eliminamos Codigo si viene en el objeto
  const { Codigo, ...productoSinCodigo } = producto;

  const { data, error } = await supabase
    .from("productos_precio")
    .insert([productoSinCodigo])
    .select("*");

  if (error) {
    console.error("[crearProducto REP]Error al insertar producto:", error.message);
    return { success: false, error: error.message };
  }

  return { success: true, data };
};

//6.////////////////////////////////////////////////////////////
export const actualizarProductoBase = async (id, cambios) => {

  // campos permitidos
  const camposPermitidos = [
    "nombre",
    "precio_unitario",
    "costo_unitario",
    "categoria",
    "Clase",
    "estado"
  ];

  // filtrar solo los campos válidos
  const cambiosFiltrados = Object.fromEntries(
    Object.entries(cambios).filter(([key]) =>
      camposPermitidos.includes(key)
    )
  );

  const { data, error } = await supabase
    .from("productos_precio")
    .update(cambiosFiltrados)
    .eq("Codigo", id)
    .select("*");

  if (error) {
    console.error("Error al actualizar producto:", error.message);
    return { success: false, error: error.message };
  }

  return { success: true, data };
};


export const cambiarEstadoProducto = async (id, activo) => {
  if (typeof activo !== 'boolean') {
    return { success: false, error: 'Estado inválido' };
  }

  return actualizarProductoBase(id, { activo });
};

//4.////////////////////////////////////////////////////////////
export const eliminarProducto = async (id) => {
    const { error } = await supabase.from('productos_precio').delete().eq('id', id);
    if (error) {
      console.error('Error al eliminar producto:', error.message);
      return { success: false, error: error.message };
    }
    return { success: true };
  };



//7
export const contarProductos = async () => {
  const { count, error } = await supabase
    .from('productos_precio')
    .select('*', { count: 'exact', head: true });

  if (error) {
    console.error('Error al contar productos:', error.message);
    return 0;
  }

  return count;
};

export const existeProducto = async (id) => {
  const { data, error } = await supabase
    .from('productos_precio')
    .select('id')
    .eq('id', id)
    .single();

  if (error) return false;
  return !!data;
};